// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gn-0";
export var actionModalContentContainer = "_gn-1";
export var createTagButton = "_gn-2";
export var footerContainer = "_gn-7";
export var fullWidthDivider = "_gn-3";
export var hasCreateTagButton = "_gn-4";
export var noCreateTagButton = "_gn-5";
export var tagsContainer = "_gn-6";
export var tagsModalContentContainer = "_gn-8";